/**
 * Polish translations for CRM Meeting Notes
 * Polskie tłumaczenia dla CRM Meeting Notes
 */

export const pl = {
  // Common
  common: {
    cancel: 'Anuluj',
    save: 'Zapisz',
    delete: 'Usuń',
    edit: 'Edytuj',
    close: 'Zamknij',
    back: 'Powrót',
    loading: 'Ładowanie...',
    error: 'Błąd',
    success: 'Sukces',
    confirm: 'Potwierdź',
    add: 'Dodaj',
    total: 'Razem',
    at: 'o',
  },

  // Authentication
  auth: {
    signIn: 'Zaloguj się',
    signOut: 'Wyloguj',
    logout: 'Wyloguj',
    email: 'Email',
    password: 'Hasło',
    successfullyLoggedIn: 'Zalogowano pomyślnie!',
    loginFailed: 'Logowanie nie powiodło się',
    signInToAccount: 'Zaloguj się do swojego konta',
  },

  // Dashboard
  dashboard: {
    title: 'Pulpit',
    welcomeBack: 'Witaj ponownie',
    quickActions: 'Szybkie akcje',
    newMeeting: 'Nowe spotkanie',
    viewHistory: 'Zobacz historię',
    adminPanel: 'Panel administratora',
    yourMeetings: 'Twoje spotkania',
    totalNotes: 'Wszystkie notatki',
    systemStatistics: 'Statystyki systemu',
    totalUsers: 'Użytkownicy',
    allMeetings: 'Wszystkie spotkania',
    allNotes: 'Wszystkie notatki',
    growth: 'Wzrost',
    recentMeetings: 'Ostatnie spotkania',
    viewAll: 'Zobacz wszystko',
    inRecentHistory: 'w ostatniej historii',
    acrossAllMeetings: 'We wszystkich spotkaniach',
    active: 'aktywni',
    thisMonth: 'w tym miesiącu',
    newUsersThisMonth: 'Nowi użytkownicy w tym miesiącu',
    loadingMeetings: 'Ładowanie spotkań...',
    noRecentMeetings: 'Brak ostatnich spotkań',
    createFirstMeeting: 'Utwórz pierwsze spotkanie',
    at: 'o',
    note: 'notatka',
    notes: 'notatki',
    failedToLoad: 'Nie udało się załadować danych pulpitu',
  },

  // Meetings
  meeting: {
    meetingDetails: 'Szczegóły spotkania',
    meetingInformation: 'Informacje o spotkaniu',
    backToHistory: 'Powrót',
    createdOn: 'Utworzono',
    date: 'Data',
    time: 'Godzina',
    location: 'Lokalizacja',
    description: 'Opis',
    enterLocation: 'Wprowadź lokalizację spotkania',
    notes: 'Notatki',
    note: 'notatka',
    addNote: 'Dodaj notatkę',
    editNote: 'Edytuj notatkę',
    deleteNote: 'Usuń notatkę',
    deleteMeeting: 'Usuń spotkanie',
    newMeeting: 'Nowe spotkanie',
    addNotes: 'Dodaj notatki',
    backToMeeting: 'Powrót do spotkania',
    addNotesToMeeting: 'Dodaj notatki do spotkania z',
    skipAndFinish: 'Pomiń i zakończ',
    finish: 'Zakończ',
    meetingSaved: 'Spotkanie zapisane!',
    meetingAndNotesSaved: 'Spotkanie i notatki zapisane pomyślnie!',
    meetingCreated: 'Spotkanie zostało utworzone',
    meetingUpdated: 'Spotkanie zaktualizowane pomyślnie',
    meetingDeleted: 'Spotkanie usunięte pomyślnie',
    failedToLoadMeeting: 'Nie udało się załadować szczegółów spotkania',
    failedToUpdateMeeting: 'Nie udało się zaktualizować spotkania',
    failedToDeleteMeeting: 'Nie udało się usunąć spotkania',
    meetingNotFound: 'Nie znaleziono spotkania',
    deleteMeetingConfirm: 'Czy na pewno chcesz usunąć to spotkanie? Tej operacji nie można cofnąć. Wszystkie powiązane notatki również zostaną usunięte.',
  },

  // Notes
  notes: {
    textNotes: 'Notatki tekstowe',
    businessCard: 'Wizytówka',
    handwritten: 'Odręczne',
    voice: 'Głosowe',
    textNote: 'Notatka tekstowa',
    voiceNote: 'Notatka głosowa',
    addNotesToMeeting: 'Dodaj notatki ze spotkania',
    yourNotes: 'Twoje notatki',
    enterNotes: 'Wpisz swoje notatki ze spotkania...',
    autoSave: 'Automatyczny zapis co 10 sekund',
    saveAndProcess: 'Zapisz i przetwórz',
    clear: 'Wyczyść',
    characters: 'znaków',
    capturingBusinessCards: 'Przechwytywanie wizytówek',
    ocrByAI: 'OCR przez AI',
    selectOrTakePhoto: 'Wybierz lub zrób zdjęcie wizytówki',
    selectFile: 'Wybierz plik',
    useCamera: 'Użyj kamery',
    handwrittenNotes: 'Notatki odręczne',
    photoOfNotes: 'Zdjęcia notatek',
    selectOrTakePhotoHandwritten: 'Wybierz lub zrób zdjęcie notatki odręcznej',
    voiceNotes: 'Notatki głosowe',
    transcriptionByAI: 'Transkrypcja przez AI',
    startRecording: 'Rozpocznij nagrywanie',
    stopRecording: 'Zatrzymaj nagrywanie',
    noNotesForMeeting: 'Brak notatek dla tego spotkania',
    noteDeleted: 'Notatka usunięta pomyślnie',
    notesAdded: 'Notatki dodane pomyślnie!',
    failedToDeleteNote: 'Nie udało się usunąć notatki',
    deleteNoteConfirm: 'Czy na pewno chcesz usunąć tę notatkę? Tej operacji nie można cofnąć.',
    completed: 'Ukończono',
    processing: 'Przetwarzanie',
    pending: 'Oczekuje',
    failed: 'Nie powiodło się',
    unknown: 'Nieznany',
    name: 'Nazwa',
    company: 'Firma',
    position: 'Stanowisko',
    phone: 'Telefon',
    transcription: 'Transkrypcja',
    audioFile: 'Plik audio',
    imageFile: 'Plik obrazu',
    noDataAvailable: 'Brak dostępnych danych',
    noContent: 'Brak treści',
    noContentAvailable: 'Brak dostępnej treści',
    noteUpdated: 'Notatka zaktualizowana pomyślnie',
    failedToUpdateNote: 'Nie udało się zaktualizować notatki',
  },

  // Admin
  admin: {
    title: 'Panel administratora',
    userManagement: 'Zarządzanie użytkownikami',
    users: 'Użytkownicy',
    addUser: 'Dodaj użytkownika',
    editUser: 'Edytuj użytkownika',
    deleteUser: 'Usuń użytkownika',
    role: 'Rola',
    admin: 'Administrator',
    user: 'Użytkownik',
  },

  // History
  history: {
    title: 'Historia spotkań',
    subtitle: 'Zobacz wszystkie swoje przeszłe spotkania i notatki',
    searchMeetings: 'Szukaj spotkań...',
    filters: 'Filtry',
    filterByDate: 'Filtruj według daty',
    from: 'Od',
    to: 'Do',
    clearFilter: 'Wyczyść filtr',
    clearFilters: 'Wyczyść filtry',
    noMeetingsFound: 'Nie znaleziono spotkań',
    showing: 'Wyświetlanie',
    of: 'z',
    meetings: 'spotkań',
    previous: 'Poprzednia',
    next: 'Następna',
    failedToLoadMeetings: 'Nie udało się załadować spotkań',
  },

  // Form validation
  validation: {
    required: 'To pole jest wymagane',
    invalidEmail: 'Nieprawidłowy adres email',
    passwordTooShort: 'Hasło musi mieć co najmniej 6 znaków',
  },
};

export default pl;
